import { toSafeString } from '@shared/utils';

const EXCLUDED_EMAIL_NAME_TOKENS = new Set(['admin', 'billing', 'contact', 'help', 'hello', 'info', 'mail', 'noreply', 'no-reply', 'notifications', 'notify', 'ops', 'operations', 'sales', 'support', 'team']);

const toTitleCase = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

const inferMemberDisplayNameFromEmail = (email) => {
  const normalizedEmail = toSafeString(email).toLowerCase();
  const localPartWithAlias = normalizedEmail.split('@')[0] || '';
  const localPart = localPartWithAlias.split('+')[0] || '';

  if (!localPart || !/^[a-z0-9._-]+$/u.test(localPart)) {
    return '';
  }

  const rawTokens = localPart.split(/[._-]+/u).filter(Boolean);

  if (rawTokens.length < 1) {
    return '';
  }

  const validTokens = rawTokens.filter((token) => {
    if (token.length < 2) {
      return false;
    }

    if (EXCLUDED_EMAIL_NAME_TOKENS.has(token)) {
      return false;
    }

    return /^[a-z]+$/u.test(token);
  });

  if (validTokens.length < 1) {
    return '';
  }

  if (rawTokens.length === 1 && validTokens.length === 1 && rawTokens[0] !== validTokens[0]) {
    return '';
  }

  return validTokens.slice(0, 2).map(toTitleCase).join(' ');
};

export default inferMemberDisplayNameFromEmail;
